import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import Css from 'Css';
import CSSPropertyOperations from 'react/lib/CSSPropertyOperations';
const { Units, Shadow, Colors } = Css;
import Portal from 'components/Portal';

const css = oxygenCss({
  root: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 900,
    transition: 'all 0.25s ease'
  },
  container: {
    position: 'relative',
    height: '100%'
  },
  padded: {
    padding: Units.base
  },
  overlay: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  },
  dialog: {
    backgroundColor: Colors.theme.Light.card,
    boxShadow: Shadow[1],
    position: 'absolute',
    left: Units.keyline * 2,
    right: Units.keyline * 2,
    top: Units.keyline * 2,
    bottom: Units.keyline * 2,
    '@phone': {
      position: 'absolute',
      left: Units.base * 2,
      right: Units.base * 2,
      top: Units.base * 2,
      bottom: Units.base * 2
    }
  }
});

const ESC = 27;

class Dialog extends Component {
  static propTypes = {
    onRequestClose: PropTypes.func,
    children: PropTypes.node,
    open: PropTypes.bool,
    onDismiss: PropTypes.func,
    padded: PropTypes.bool
  };

  componentWillMount() {
    this._overflow = document.body.style.overflow;
    document.addEventListener('keyup', this.handleKey);
    this.reset(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.reset(nextProps);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleKey);
    this.reset({ open: false });
  }

  reset = props => {
    const { open } = props;

    if (!open) {
      CSSPropertyOperations.setValueForStyles(document.body, {
        overflow: this._overflow
      });
    } else {
      CSSPropertyOperations.setValueForStyles(document.body, {
        overflow: 'hidden'
      });
    }
  };

  handleKey = event => {
    const { keyCode } = event;
    if (keyCode === ESC) {
      this.requestClose();
    }
  };

  requestClose = () => {
    const { onRequestClose } = this.props;
    onRequestClose && onRequestClose();
  };

  render() {
    const { padded, children, open } = this.props;
    if (!open) {
      return null;
    }
    return (
      <Portal>
        <div className={css.root}>
          <div className={css.overlay} onTouchTap={this.requestClose} />
          <div className={css.dialog}>
            <div className={classNames(css.container, padded && css.padded)}>
              {children}
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/js/components/Dialog/Dialog.js